(function () {
  if (window.__promoBarCarouselInit) return;
  window.__promoBarCarouselInit = true;

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function formatRemaining(ms) {
    var totalSeconds = Math.floor(ms / 1000);
    var hours = Math.floor(totalSeconds / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;
    return pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
  }

  document.addEventListener('DOMContentLoaded', function () {
    var bar = document.querySelector('[data-promo-bar]');
    if (!bar) return;

    var slides = Array.prototype.slice.call(bar.querySelectorAll('[data-promo-slide]'));
    if (!slides.length) return;

    var rotateMs = (parseInt(bar.dataset.rotateSeconds, 10) || 4) * 1000;
    var visibleIndex = 0;
    var rotateInterval = null;

    // Pré-calcule les infos de chaque slide (timer ou non)
    var slideInfo = slides.map(function (slide) {
      var hasTimer = 'start' in slide.dataset;
      return {
        el: slide,
        hasTimer: hasTimer,
        start: hasTimer ? new Date(slide.dataset.start) : null,
        end: hasTimer ? new Date(slide.dataset.end) : null,
        timerEl: slide.querySelector('[data-promo-timer]')
      };
    });

    function isActive(info) {
      if (!info.hasTimer) return true;
      var now = new Date();
      return now >= info.start && now < info.end;
    }

    function showOnly(index) {
      slideInfo.forEach(function (info, i) {
        info.el.classList.toggle('is-visible', i === index);
      });
    }

    function stopRotation() {
      if (rotateInterval) {
        clearInterval(rotateInterval);
        rotateInterval = null;
      }
    }

    function startRotation(activeIndexes) {
      stopRotation();
      var pos = 0;
      showOnly(activeIndexes[pos]);
      rotateInterval = setInterval(function () {
        pos = (pos + 1) % activeIndexes.length;
        showOnly(activeIndexes[pos]);
      }, rotateMs);
    }

    function refresh() {
      var now = new Date();
      var activeIndexes = [];

      slideInfo.forEach(function (info, i) {
        var active = isActive(info);

        if (info.hasTimer) {
          if (active) {
            var remaining = info.end - now;
            if (info.timerEl) info.timerEl.textContent = formatRemaining(remaining);

            var ONE_HOUR = 60 * 60 * 1000;
            var SIX_HOURS = 6 * ONE_HOUR;
            info.el.classList.toggle('is-urgent', remaining <= SIX_HOURS && remaining > ONE_HOUR);
            info.el.classList.toggle('is-critical', remaining <= ONE_HOUR);
          } else {
            info.el.classList.remove('is-urgent', 'is-critical');
          }
        }

        if (active) activeIndexes.push(i);
      });

      if (!activeIndexes.length) {
        bar.hidden = true;
        stopRotation();
        return;
      }

      bar.hidden = false;

      if (activeIndexes.length === 1) {
        stopRotation();
        showOnly(activeIndexes[0]);
      } else {
        // (Re)démarre la rotation seulement si l'ensemble des slides actives a changé
        var key = activeIndexes.join(',');
        if (bar.dataset.activeKey !== key) {
          bar.dataset.activeKey = key;
          startRotation(activeIndexes);
        }
      }
    }

    refresh();
    setInterval(refresh, 1000);
  });
})();